import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Globe2 } from "lucide-react";
export function Logo({ compact = false }) {
    return _jsxs("div", { className: "logo", children: [_jsx("span", { className: "logo-mark", children: _jsx(Globe2, { size: 20 }) }), !compact && _jsxs("span", { children: ["GlobeDine", _jsx("small", { children: "GLOBAL DINING OS" })] })] });
}
export function Button({ className = "", variant = "primary", ...props }) {
    return _jsx("button", { className: `button ${variant} ${className}`, ...props });
}
export function Badge({ children, tone = "neutral" }) {
    return _jsx("span", { className: `badge ${tone}`, children: children });
}
export function StatCard({ label, value, detail, icon }) {
    return _jsxs("article", { className: "stat-card", children: [_jsx("div", { className: "stat-icon", children: icon }), _jsxs("div", { children: [_jsx("span", { children: label }), _jsx("strong", { children: value }), detail && _jsx("small", { children: detail })] })] });
}
export function Panel({ title, action, className = "", children }) {
    return _jsxs("section", { className: `panel ${className}`, children: [(title || action) && _jsxs("header", { className: "panel-header", children: [_jsx("h2", { children: title }), action] }), children] });
}
export function EmptyState({ icon, title, detail }) {
    return _jsxs("div", { className: "empty-state", children: [_jsx("div", { children: icon }), _jsx("strong", { children: title }), detail && _jsx("p", { children: detail })] });
}
export function formatMoney(amount, currency, locale = "en") {
    try {
        return new Intl.NumberFormat(locale, { style: "currency", currency, maximumFractionDigits: currency === "VND" ? 0 : 2 }).format(amount);
    }
    catch {
        return `${amount.toLocaleString()} ${currency}`;
    }
}
export function timeAgo(value, locale = "en") {
    const minutes = Math.max(0, Math.round((Date.now() - new Date(value).getTime()) / 60_000));
    if (minutes < 1)
        return locale.startsWith("zh") ? "刚刚" : "just now";
    if (locale.startsWith("zh"))
        return `${minutes} 分钟前`;
    return `${minutes}m ago`;
}
export function orderTone(status) {
    if (["ready", "served", "completed", "printed"].includes(status))
        return "green";
    if (["preparing", "confirmed", "claimed"].includes(status))
        return "blue";
    if (["awaiting_confirmation", "pending", "queued", "waiting"].includes(status))
        return "amber";
    if (["cancelled", "failed"].includes(status))
        return "red";
    return "neutral";
}
//# sourceMappingURL=index.js.map